/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAirport = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M21.816 4.932c-.431-.822-1.412-1.117-2.19-.663L14.87 7 5.722 4.086A.95.95 0 0 0 5.332 4c-.542 0-.978.46-.978 1.029 0 .298.122.566.313.755l.008.005a1 1 0 0 0 .135.107l5.001 4.01-2.88 1.652-3.77-.832a.8.8 0 0 0-.331-.073c-.457 0-.83.39-.83.873 0 .22.077.42.204.572l.003.003q.076.093.176.158L4.303 14h4.941l12.003-6.97c.704-.414.962-1.351.569-2.098M17 19H2v-1.5h15V19" /></svg>;
export default SvgAirport;